module.exports = __webpack_public_path__ + "img/unanswered-responses.1f6bbd3d.svg";